var LanguageEnum = /* @__PURE__ */ ((LanguageEnum2) => {
  LanguageEnum2["Ru"] = "ru";
  LanguageEnum2["En"] = "en";
  LanguageEnum2["Uz"] = "uz";
  LanguageEnum2["Ar"] = "ar";
  return LanguageEnum2;
})(LanguageEnum || {});
const LANGUAGES_MAP = {
  [
    "en"
    /* En */
  ]: "en-US",
  [
    "ru"
    /* Ru */
  ]: "ru-RU",
  [
    "uz"
    /* Uz */
  ]: "ru-RU",
  [
    "ar"
    /* Ar */
  ]: "ar-SA"
};
export {
  LANGUAGES_MAP,
  LanguageEnum
};
